/**
 * Kişi read model (GET /people/{id}/activity, v0.1.64): the contract's shape, re-exported so
 * the screen imports from one place, plus the Turkish words the page uses. Read only.
 */

export type {
  PersonActivity,
  PersonCounters,
  PersonEvent,
  PersonEventKind,
  PersonKind,
  PersonTool,
} from '@twin/contracts';

/** The counters a person's header shows, in order, with their Turkish labels; zeros are skipped. */
export const PERSON_COUNTER_LABELS: readonly { key: keyof import('@twin/contracts').PersonCounters; label: string }[] =
  [
    { key: 'runs', label: 'çalışma' },
    { key: 'runsFailed', label: 'düşen çalışma' },
    { key: 'proposals', label: 'öneri' },
    { key: 'proposalsApproved', label: 'onaylanan öneri' },
    { key: 'proposalsRejected', label: 'reddedilen öneri' },
    { key: 'proposalsPending', label: 'bekleyen öneri' },
    { key: 'decisions', label: 'karar' },
    { key: 'approved', label: 'onay' },
    { key: 'edited', label: 'düzenleyip onay' },
    { key: 'rejected', label: 'ret' },
    { key: 'questionsRaised', label: 'soru' },
    { key: 'questionsAnswered', label: 'cevap' },
    { key: 'sends', label: 'Gmail gönderimi' },
    { key: 'ownReplies', label: 'kendi cevabı' },
    { key: 'searches', label: 'tarama' },
    { key: 'searchQueries', label: 'arama sorgusu' },
    { key: 'toolCalls', label: 'araç çağrısı' },
  ];

export const PERSON_EVENT_LABELS: Readonly<Record<string, string>> = Object.freeze({
  run: 'Çalışma',
  proposal: 'Öneri',
  decision: 'Karar',
  question: 'Soru',
  answer: 'Cevap',
  send: 'Gönderim',
  own_reply: 'Kendi cevabı',
  search: 'Tarama',
});

export const TOOL_LABELS_TR: Readonly<Record<string, string>> = Object.freeze({
  kb_search: 'Bilgi bankası araması',
  product_card_get: 'Ürün kartı okuma',
  market_vehicle_check: 'Pazar kontrolü',
  etsy_orders_read: 'Etsy sipariş okuma',
  etsy_listings_read: 'Etsy ilan okuma',
  propose_action: 'Öneri',
  unknown_question_raise: 'Soru açma',
  task_create: 'Görev açma',
  web_search: 'Web araması',
  page_fetch: 'Sayfa okuma',
});

export function toolLabel(tool: string): string {
  return TOOL_LABELS_TR[tool] ?? tool;
}
